module.exports = __webpack_public_path__ + "img/Degu.8a67145b.png";